// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Input

Input styling based on \`.c-input\` block class and it\`s modifiers.

*/
/*
Input

markup:
<input class="c-input" id="input1" placeholder="Text Input" type="text">
<input class="c-input" id="input2" placeholder="Readonly Input" type="text" readonly value="Unchangeble info">
<input class="c-input" id="input3" placeholder="Disabled Input" type="text" disabled>
<input class="c-input" id="input4" placeholder="Input type='email'" type="email">
<input class="c-input" id="input5" placeholder="Input type='tel'" type="tel">
<input class="c-input" id="input6" placeholder="Input type='search'" type="search">
<input class="c-input" id="input7" placeholder="Input type='number'" type="number">
<input class="c-input" id="input8" placeholder="Input type='date'" type="date">

*/
/*
Input Block

Input on full width of it\`s parent.

markup:
<input id="input1" placeholder="Full width of parent container" class="c-input c-input_block" type="text">

*/
/*
Input Text Right

Text right aligning inside input.

markup:
<input class="c-input c-input_text-right" placeholder="Type something..." type="text">

*/
/*
Input Length

c-input_xtiny - xtiny length (88px)
c-input_tiny - tiny length (106px)
c-input_small - small  length
c-input_regular - regular length
c-input_large - large length
c-input_huge - huge length

markup:
<input class="c-input {\$modifiers}" placeholder="Input length {\$modifiers}" type="text">

*/
/*
Bare Input

markup:
<input class="c-input c-input_bare" placeholder="Type something..." type="text">

*/
/**
 * Text inputs with no styles.
 */
/*
Input Validation

c-input_is-success - Success input style
c-input_is-warning - Warning input style
c-input_is-error - Error input style

markup:
<input class="c-input {\$modifiers}" placeholder="Validation class .{\$modifiers}" type="text">

*/
/**
 * Styles for validation states
 */
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*

Buttons

markup:
<button class="c-btn">
  Button
</button>

*/
/**
 * 1. Allow us to style box model properties.
 * 2. Line different sized buttons up a little nicer.
 * 3. Make buttons inherit font styles (often necessary when styling \`input\`s as
 *    buttons).
 * 4. Reset/normalize some styles.
 * 5. Force all button-styled elements to appear clickable.
 */
/*
Style variants

bare - Buttons with no styles (good a11y practice to use <button></button> for actions rather than <a></a>)
link - Link buttons
primary - The primary action of the page it is placed on. Place only one primary button on each page/dialog.
secondary - Secondary buttons
tertiary - Tertiary buttons
disabled - Action is disabled. Buttons using this modifier should not be clickable.
active - Active or toggled. Buttons using this modifier should not be clickable.
destroy - A destructive action which can't be undone and might involve loss of data.

markup:
<button class="c-btn c-btn_{\$modifiers}" type="button">
  Button
</button>

*/
/*
Ghost buttons

Ghost buttons have see-through backgrounds and are bordered.

small - small button with small horizontal spacing and tiny vertical spacing.
large - large button with large horizontal spacing and default vertical spacing.
full - Use this modifier to force a button to fill its parent's width.
primary - primary colored button. Use to make accent to action.
secondary - secondary button.
tertiary - tertiary button.

markup:
<button class="c-btn c-btn_ghost c-btn_{\$modifiers}" type="button">
  Button
</button>

*/
/*
Size variants

small - small button with small horizontal spacing and tiny vertical spacing.
large - large button with large horizontal spacing and default vertical spacing.
full - Use this modifier to force a button to fill its parent's width.

markup:
<button type="button" class="c-btn c-btn_{\$modifiers}">
  Button
</button>

*/
/*
Round iconic buttons

markup:
<button class="c-btn c-btn_icon" type="button">
  <span class="fa fa-user"></span>
</button>

*/
/*
Datepicker button

For use in datepicker as datepicker button in calendar.

markup:
<button class="c-btn _c-btn_datepicker" type="button">
  24
</button>

*/
/*
Round iconic buttons

markup:
<button class="c-btn c-btn_menu-toggle" type="button">
  <span class="fa fa-user"></span>
</button>

<button class="c-btn c-btn_border-free" type="button">
  <span class="fa fa-user"></span>
</button>

Styleguide 6.1.1.5
*/
/*
Inline buttons

markup:
<button class="c-btn c-btn_inline" type="button">
  <span class="fa fa-user"></span>
</button>
<button class="c-btn c-btn_inline" type="button">
  <span class="fa fa-calendar"></span>
</button>

*/
/*
Grouped buttons

For use in Button group components

markup:
<button class="c-btn _c-btn_grouped" type="button">
  <span class="fa fa-user"></span>
</button>

*/
/*
Underlined buttons

For use in Tabs as tab labels. To prevent jumping use c-btn_underlined-transparent

markup:
<button class="c-btn c-btn_underlined" type="button">
  <span class="fa fa-user"></span>
</button>

Styleguide 6.1.1.9
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*

Buttons

markup:
<button class="c-btn">
  Button
</button>

*/
/**
 * 1. Allow us to style box model properties.
 * 2. Line different sized buttons up a little nicer.
 * 3. Make buttons inherit font styles (often necessary when styling \`input\`s as
 *    buttons).
 * 4. Reset/normalize some styles.
 * 5. Force all button-styled elements to appear clickable.
 */
/*
Style variants

bare - Buttons with no styles (good a11y practice to use <button></button> for actions rather than <a></a>)
link - Link buttons
primary - The primary action of the page it is placed on. Place only one primary button on each page/dialog.
secondary - Secondary buttons
tertiary - Tertiary buttons
disabled - Action is disabled. Buttons using this modifier should not be clickable.
active - Active or toggled. Buttons using this modifier should not be clickable.
destroy - A destructive action which can't be undone and might involve loss of data.

markup:
<button class="c-btn c-btn_{\$modifiers}" type="button">
  Button
</button>

*/
/*
Ghost buttons

Ghost buttons have see-through backgrounds and are bordered.

small - small button with small horizontal spacing and tiny vertical spacing.
large - large button with large horizontal spacing and default vertical spacing.
full - Use this modifier to force a button to fill its parent's width.
primary - primary colored button. Use to make accent to action.
secondary - secondary button.
tertiary - tertiary button.

markup:
<button class="c-btn c-btn_ghost c-btn_{\$modifiers}" type="button">
  Button
</button>

*/
/*
Size variants

small - small button with small horizontal spacing and tiny vertical spacing.
large - large button with large horizontal spacing and default vertical spacing.
full - Use this modifier to force a button to fill its parent's width.

markup:
<button type="button" class="c-btn c-btn_{\$modifiers}">
  Button
</button>

*/
/*
Round iconic buttons

markup:
<button class="c-btn c-btn_icon" type="button">
  <span class="fa fa-user"></span>
</button>

*/
/*
Datepicker button

For use in datepicker as datepicker button in calendar.

markup:
<button class="c-btn _c-btn_datepicker" type="button">
  24
</button>

*/
/*
Round iconic buttons

markup:
<button class="c-btn c-btn_menu-toggle" type="button">
  <span class="fa fa-user"></span>
</button>

<button class="c-btn c-btn_border-free" type="button">
  <span class="fa fa-user"></span>
</button>

Styleguide 6.1.1.5
*/
/*
Inline buttons

markup:
<button class="c-btn c-btn_inline" type="button">
  <span class="fa fa-user"></span>
</button>
<button class="c-btn c-btn_inline" type="button">
  <span class="fa fa-calendar"></span>
</button>

*/
/*
Grouped buttons

For use in Button group components

markup:
<button class="c-btn _c-btn_grouped" type="button">
  <span class="fa fa-user"></span>
</button>

*/
/*
Underlined buttons

For use in Tabs as tab labels. To prevent jumping use c-btn_underlined-transparent

markup:
<button class="c-btn c-btn_underlined" type="button">
  <span class="fa fa-user"></span>
</button>

Styleguide 6.1.1.9
*/
/* ==========================================================================
   #BUTTON GROUPS
   ========================================================================== */
/*
Button groups

Actions that logically belong together might be grouped by wrapping them in a container with .c-btn-group.

Each action button must have the modifier class .c-btn_grouped.

Wrap several groups in a .c-btn-group-row to keep them in one line. Each one must have the modifier class  .c-btn-group_in-row.

Please do not use the button group as tabs.

markup:
<div class="c-btn-group">
	<button class="c-btn c-btn_in-btn-group c-btn_large">1</button>
	<button class="c-btn c-btn_in-btn-group c-btn_large">
        <i class="c-icon c-icon_check c-icon_btn c-icon_btn-large"></i>
    </button>
	<button class="c-btn c-btn_in-btn-group c-btn_large">2</button>
	<button class="c-btn c-btn_in-btn-group c-btn_large c-btn_destroy">
        <i class="c-icon c-icon_trash c-icon_btn c-icon_btn-large"></i>
    </button>
</div>

*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Checkbox

markup:
<label class="c-checkbox">
  <input class="c-checkbox__input" type="checkbox">
  <i class="c-checkbox__icon"></i>
  Checkbox
</label>
<label class="c-checkbox">
  <input class="c-checkbox__input" type="checkbox">
  <i class="c-checkbox__icon"></i>
  <span class="c-checkbox__label">Checkbox with custom label</span>
</label>
<label class="c-checkbox">
  <input type="checkbox" class="c-checkbox__input" disabled >
  <i class="c-checkbox__icon"></i>
  Check Disabled
</label>
<label class="c-checkbox">
  <input type="checkbox" class="c-checkbox__input" checked>
  <i class="c-checkbox__icon"></i>
  Check that
</label>
<label class="c-checkbox">
  <input type="checkbox" class="c-checkbox__input" checked disabled >
  <i class="c-checkbox__icon"></i>
  Check Disabled
</label>
<label class="c-checkbox" for="input_indeterminate">
  <input type="checkbox" class="c-checkbox__input" id="input_indeterminate" onclick="(function(){document.getElementById('input_indeterminate').indeterminate = true;}).call(this)">
  <i class="c-checkbox__icon"></i>
  Click to make me indeterminate!
</label>
<label class="c-checkbox" for="input_indeterminate_disabled">
  <input type="checkbox" class="c-checkbox__input" id="input_indeterminate_disabled" onclick="(function(){document.getElementById('input_indeterminate_disabled').indeterminate = true; document.getElementById('input_indeterminate_disabled').disabled = true;}).call(this)">
  <i class="c-checkbox__icon"></i>
  Click to make me indeterminate and disabled!
</label>

*/
/*
Checkbox with custom label

You can customize label view and even hide label. Just wrap it with \`c-checkbox__label\` span.

To hide label use \`sr-only\` class on \`.c-checkbox__label\` element. Do not remove label from html.

markup:
<label class="c-checkbox">
  <input class="c-checkbox__input" type="checkbox">
  <i class="c-checkbox__icon"></i>
  <span class="c-checkbox__label">Checkbox with custom label</span>
</label>
<label class="c-checkbox">
  <input class="c-checkbox__input" type="checkbox">
  <i class="c-checkbox__icon"></i>
  <span class="c-checkbox__label sr-only">Checkbox with custom label</span>
</label>

*/
/*
Checkbox Switch

markup:
<label class="c-checkbox c-checkbox_switch">
  <input type="checkbox" class="c-checkbox__input">
  <i class="c-checkbox__icon"></i>
  <span class="c-checkbox__label">Switch control</span>
</label>
<label class="c-checkbox c-checkbox_switch">
  <input type="checkbox" class="c-checkbox__input" disabled >
  <i class="c-checkbox__icon"></i>
  <span class="c-checkbox__label">Check Disabled</span>
</label>
<label class="c-checkbox c-checkbox_switch">
  <input type="checkbox" class="c-checkbox__input" checked>
  <i class="c-checkbox__icon"></i>
  <span class="c-checkbox__label">Check that</span>
</label>
<label class="c-checkbox c-checkbox_switch">
  <input type="checkbox" class="c-checkbox__input" checked disabled >
  <i class="c-checkbox__icon"></i>
  <span class="c-checkbox__label">Check Disabled</span>
</label>

*/
/*
Two values Switch

markup:
<label class="c-checkbox c-checkbox_switch c-checkbox_switch-two-values">
  <span class="c-checkbox__label u-margin-right-tiny">Value 1</span>
  <input type="checkbox" class="c-checkbox__input">
  <i class="c-checkbox__icon"></i>
  <span class="c-checkbox__label">Value 2</span>
</label>

*/
/*
Two values Switch with on and off states

markup:
<label class="c-checkbox c-checkbox_switch c-checkbox_switch-two-values c-checkbox_switch-on-off">
  <span class="c-checkbox__label u-margin-right-tiny">Value 1</span>
  <input type="checkbox" class="c-checkbox__input">
  <i class="c-checkbox__icon"></i>
  <span class="c-checkbox__label">Value 2</span>
</label>

*/
/*
Inline Checkbox

Group checkboxes on the same horizontal row by adding \`.c-checkbox_inline\` to any \`.c-checkbox\`.

markup:
<label class="c-checkbox c-checkbox_inline">
  <input type="checkbox" class="c-checkbox__input" id="ci1">
  <i class="c-checkbox__icon"></i>
  <span class="c-checkbox__label">Check this</span>
</label>
<label class="c-checkbox c-checkbox_inline">
  <input type="checkbox" class="c-checkbox__input" id="ci3" disabled >
  <i class="c-checkbox__icon"></i>
  <span class="c-checkbox__label">Check Disabled</span>
</label>
<label class="c-checkbox c-checkbox_switch c-checkbox_inline">
  <input type="checkbox" class="c-checkbox__input" id="ci22" checked>
  <i class="c-checkbox__icon"></i>
  <span class="c-checkbox__label">Check that</span>
</label>
<label class="c-checkbox c-checkbox_switch c-checkbox_inline">
  <input type="checkbox" class="c-checkbox__input" id="ci22" checked>
  <i class="c-checkbox__icon"></i>
  <span class="c-checkbox__label">Check that</span>
</label>

*/
/*
Compact Checkbox

Remove vertical margin from checkboxes using class \`c-checkbox_compact\`.

markup:
<label class="c-checkbox c-checkbox_compact">
  <input type="checkbox" class="c-checkbox__input">
  <i class="c-checkbox__icon"></i>
  <span class="c-checkbox__label">Check this</span>
</label>

*/
/* ==========================================================================
   #CROP
   ========================================================================== */
/*
Crop

Provide a cropping container in order to display media (usually images) cropped to certain ratios.
 1. Set up a positioning context in which the image can sit.
 2. This is the crucial part: where the cropping happens.

markup:
<div>Croup image in 16:9</div>
<div class="o-crop o-crop_16:9">
  <img class="o-crop__content" src="http://www.uniwallpaper.com/static/images/6890733-mountain-peaks-wallpaper-hd_PZTQDff.jpg" alt="thmthg"/>
</div>

*/
/**
 * Provide a cropping container in order to display media (usually images)
 * cropped to certain ratios.
 *
 * 1. Set up a positioning context in which the image can sit.
 * 2. This is the crucial part: where the cropping happens.
 */
/**
 * Apply this class to the content (usually \`img\`) that needs cropping.
 *
 * 1. Image’s default positioning is top-left in the cropping box.
 * 2. Make sure the media doesn’t stop itself too soon.
 */
/**
 * We can position the media in different locations within the cropping area.
 */
/*
Crop positioning

We can position the media in different locations within the cropping area.

right - position to the right corner
bottom - position to the bottom corner
center - central positioning

markup:
<div>Croup positioning - {\$modifiers}</div>
<div class="o-crop o-crop_16:9">
  <img class="o-crop__content o-crop__content_{\$modifiers}" src="http://www.uniwallpaper.com/static/images/6890733-mountain-peaks-wallpaper-hd_PZTQDff.jpg" alt="thmthg"/>
</div>

*/
/* stylelint-disable */
/* Crop-ratio variants.
   ========================================================================== */
/**
 * Generate a series of crop classes to be used like so:
 *
 *   <div class="o-crop  o-crop_16:9">
 *
 */
/* stylelint-enable */
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Inline form

Use the .form-inline class to display a series of labels, form controls, and buttons on a single horizontal row.
Form controls within inline forms vary slightly from their default states.

Controls are display: flex, collapsing any HTML white space and allowing you to provide alignment control with spacing
and flexbox utilities.

Controls and input groups receive width: auto to override the Bootstrap default width: 100%.

Controls only appear inline in viewports that are at least 576px wide to account for narrow viewports on mobile devices.

You may need to manually address the width and alignment of individual form controls with spacing utilities (as shown below).

Lastly, be sure to always include a <label> with each form control, even if you need to hide it from non-screenreader visitors with .sr-only.

markup:
<form class="c-form c-form_inline">
  <div class="c-form-group">
    <label class="c-label" for="input222">
      <span class="c-label__content c-label__content_inline">Input Label</span>
      <input id="input222" placeholder="Type something..." class="c-input c-input_small" type="text">
    </label>
  </div>
  <div class="c-form-group">
    <label class="c-label" for="inputfl2" >Readonly Input</label>
    <input class="c-input" id="inputfl2" placeholder="Type something..." type="text" readonly value="Unchangeble info">
  </div>
  <div class="c-form-group">
    <label class="c-checkbox c-checkbox_inline">
      <input type="checkbox" class="c-checkbox__input" id="ci1">
      <i class="c-checkbox__icon"></i>
      <span class="c-checkbox__label">Check this</span>
    </label>
    <label class="c-checkbox c-checkbox_inline">
      <input type="checkbox" class="c-checkbox__input" id="ci1">
      <i class="c-checkbox__icon"></i>
      <span class="c-checkbox__label">Check this</span>
    </label>
  </div>
</form>

*/
/*
Compact form

For forms inside of smaller containers like modals or wizards, the whitespace around form groups and form blocks can be
minimized by using the .c-form_compact classname.

markup:
<form class="c-form c-form_compact">
  <div class="c-form-group">
    <label class="c-label for="inputflc1" >Text Input</label>
    <input class="c-input" id="inputflc1" placeholder="Type something..." type="text">
  </div>
  <div class="c-form-group">
    <label class="c-label" for="inputflc2" >Readonly Input</label>
    <input class="c-input" id="inputflc2" placeholder="Type something..." type="text" readonly value="Unchangeble info">
  </div>
  <div class="c-form-group">
    <label class="c-checkbox c-checkbox_inline">
      <input type="checkbox" class="c-checkbox__input" id="ci1">
      <i class="c-checkbox__icon"></i>
      <span class="c-checkbox__label">Check this</span>
    </label>
    <label class="c-checkbox c-checkbox_inline">
      <input type="checkbox" class="c-checkbox__input" id="ci1">
      <i class="c-checkbox__icon"></i>
      <span class="c-checkbox__label">Check this</span>
    </label>
  </div>
</form>

*/
/*
Form Inside a Grid

Forms can be used in a grid. Extend the .o-grid class on a .c-form-group and place the form fields in the grid column
classes. To occupy 100% of the column width, extend the .c-input_block class on the form field. Resize your browser to
see how forms in grids work.

To align Label with input use \`.c-label__content_inline\` modifier on \`.c-label__content\`.

markup:
<form class="c-form">
  <section class="c-form-block">
    <h3>Form Inside a Grid</h3>
    <div class="c-form-group o-grid">
      <div class="o-grid__cell">
        <label class="c-label" for="inputflg1" >
          <span class="c-label__content c-label__content_inline">Text Input</span>
        </label>
      </div>
      <div class="o-grid__cell o-grid__cell_width-75">
        <input class="c-input c-input_block" id="inputflg1" placeholder="Type something..." type="text">
      </div>
    </div>
    <div class="c-form-group o-grid">
      <div class="o-grid__cell">
        <label class="c-label" for="inputflg2" >
          <span class="c-label__content c-label__content_inline">Readonly Input</span>
        </label>
      </div>
      <div class="o-grid__cell o-grid__cell_width-75">
        <input class="c-input c-input_block" id="inputflg2" placeholder="Type something..." type="text" readonly value="Unchangeble info">
      </div>
    </div>
    <div class="c-form-group o-grid">
      <label class="c-checkbox c-checkbox_inline">
        <input type="checkbox" class="c-checkbox__input" id="ci1">
        <i class="c-checkbox__icon"></i>
        <span class="c-checkbox__label">Check this</span>
      </label>
      <label class="c-checkbox c-checkbox_inline">
        <input type="checkbox" class="c-checkbox__input" id="ci1">
        <i class="c-checkbox__icon"></i>
        <span class="c-checkbox__label">Check this</span>
      </label>
    </div>
    <button class="c-btn c-btn_primary" type="submit">Button</button>
  </section>
</form>

*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Form-group

The .c-form-group class is the easiest way to add some structure to forms. Its only purpose is to provide margin-bottom
around a label and control pairing. As a bonus, since it’s a class you can use it with <fieldset>s, <div>s, or nearly
any other element.

The recommendation is for .c-form-group classnames to be placed on div elements.

markup:
<div class="c-form-group">
  <label class="c-label for="inputfg1" >Text Input</label>
  <input class="c-input" id="inputfg1" placeholder="Type something..." type="text">
</div>
<div class="c-form-group">
  <label class="c-label" for="inputfg2" >Readonly Input</label>
  <input class="c-input" id="inputfg2" placeholder="Type something..." type="text" readonly value="Unchangeble info">
</div>
<div class="c-form-group">
  <label class="c-checkbox">
    <input class="c-checkbox__input" type="checkbox">
    <i class="c-checkbox__icon"></i>
    Checkbox
  </label>
  <label class="c-checkbox">
    <input class="c-checkbox__input" type="checkbox">
    <i class="c-checkbox__icon"></i>
    Checkbox
  </label>
</div>

*/
/* ==========================================================================
   #GRID
   ========================================================================== */
/*
Grid (also flexbox)

Deprecated: For flexbox grid use Flexbox object. It has much more options and better integration to SEM NEXT UI.
We’ll drop support for these wikis on April 20, 2017.

The grid is the easiest way to produce a fluid responsive layout. Its easy to use and very flexible.

* Color key:
 * grids are pink
 * cells are blue
 * padding is green

markup:
<div class="o-grid o-grid_demo">
  <div class="o-grid__cell">
    <div class="o-grid-text">
      first
    </div>
  </div>
  <div class="o-grid__cell">
    <div class="o-grid-text">
      second
    </div>
  </div>
  <div class="o-grid__cell">
    <div class="o-grid-text">
      third
    </div>
  </div>
</div>

*/
/*
Width

Deprecated: For flexbox grid use Flexbox object. It has much more options and better integration to SEM NEXT UI.
We’ll drop support for these wikis on April 20, 2017.

Use the \`.o-grid__cell_width-xx\` class to apply widths to your cells. If you add a width to one cell the other cells will
automatically take up the rest of the space equally.

markup:
<div class="o-grid o-grid_demo">
    <div class="o-grid__cell o-grid__cell_width-50">
        <div class="o-grid-text">first</div>
    </div>
    <div class="o-grid__cell">
        <div class="o-grid-text">second</div>
    </div>
    <div class="o-grid__cell">
        <div class="o-grid-text">third</div>
    </div>
</div>

*/
/*
Offsets

Deprecated: For flexbox grid use Flexbox object. It has much more options and better integration to SEM NEXT UI.
We’ll drop support for these wikis on April 20, 2017.

To "push" a cell horizontally across the grid use the \`.o-grid__cell_offset-xx\` class. Use in conjunction with widths to
perfectly align your cells.

markup:
<div class="o-grid o-grid_demo">
    <div class="o-grid__cell o-grid__cell_width-20">
        <div class="o-grid-text">first</div>
    </div>
    <div class="o-grid__cell o-grid__cell_width-20 o-grid__cell_offset-60">
        <div class="o-grid-text">second</div>
    </div>
</div>

*/
/*
Wrapping

Deprecated: For flexbox grid use Flexbox object. It has much more options and better integration to SEM NEXT UI.
We’ll drop support for these wikis on April 20, 2017.

A grid is essentially a row of cells. However cells can wrap onto the next line within the grid.

Here we have 2 cells, 50% and 66.6666% wide, but the grid is only 100% wide...eek!

markup:
<div class="o-grid o-grid_demo">
    <div class="o-grid__cell o-grid__cell_width-50">
        <div class="o-grid-text">first</div>
    </div>
    <div class="o-grid__cell o-grid__cell_width-66">
        <div class="o-grid-text">second</div>
    </div>
</div>

*/
/*
Nesting

Deprecated: For flexbox grid use Flexbox object. It has much more options and better integration to SEM NEXT UI.
We’ll drop support for these wikis on April 20, 2017.

You can nest grids inside cells with relative ease...with nesting you're into advanced territory!

markup:
<div class="o-grid o-grid_demo">
    <div class="o-grid__cell">
        <div class="o-grid">
            <div class="o-grid__cell">
                <div class="o-grid-text">first</div>
            </div>
            <div class="o-grid__cell">
                <div class="o-grid-text">second</div>
            </div>
        </div>
        <div class="o-grid">
            <div class="o-grid__cell">
                <div class="o-grid-text">third</div>
            </div>
            <div class="o-grid__cell">
                <div class="o-grid-text">fourth</div>
            </div>
        </div>
    </div>
    <div class="o-grid__cell">
        <div class="o-grid-text">fifth</div>
    </div>
</div>

*/
/*
Vertical Alignment

Deprecated: For flexbox grid use Flexbox object. It has much more options and better integration to SEM NEXT UI.
We’ll drop support for these wikis on April 20, 2017.

Per \`.o-grid\`

If one of your cells is tall you can apply a vertical alignment modifier class to the grid.
\`.o-grid_top\`, \`.o-grid_center\` and \`.o-grid_bottom\` are supported.

Per \`.o-grid__cell\`

You can override the vertical alignment of all the cells in the grid by specifying per cell.
\`.o-grid__cell_top\`, \`.o-grid__cell_center\` and \`.o-grid__cell_bottom\` are supported.

markup:
<div>Per .o-grid</div>
<div class="o-grid o-grid_bottom o-grid_demo">
    <div class="o-grid__cell">
        <div class="o-grid-text">first</div>
    </div>
    <div class="o-grid__cell">
        <div class="o-grid-text">second</div>
    </div>
    <div class="o-grid__cell">
        <div class="o-grid-text">third</div>
    </div>
    <div class="o-grid__cell">
        <div class="o-grid-text">fourth
            <br>fourth
            <br>fourth
            <br>fourth
            <br>fourth
            <br>
        </div>
    </div>
    <div class="o-grid-text"></div>
</div>
<div>Per .o-grid</div>
<div class="o-grid o-grid_bottom o-grid_demo">
    <div class="o-grid__cell o-grid__cell_top">
        <div class="o-grid-text">first</div>
    </div>
    <div class="o-grid__cell o-grid__cell_center">
        <div class="o-grid-text">second</div>
    </div>
    <div class="o-grid__cell">
        <div class="o-grid-text">third</div>
    </div>
    <div class="o-grid__cell">
        <div class="o-grid-text">fourth
            <br>fourth
            <br>fourth
            <br>fourth
            <br>fourth
            <br>
        </div>
    </div>
</div>

*/
/*
Gutters

Deprecated: For flexbox grid use Flexbox object. It has much more options and better integration to SEM NEXT UI.
We’ll drop support for these wikis on April 20, 2017.

Grid comes with a gutter around each grid cell; some padding either side.
Sometimes you want your cells to be flush with each other. To turn off all gutters use \`.o-grid_no-gutter\`
or cell specific \`.o-grid__cell_no-gutter\`

markup:
<div>to whole o-grid</div>
<div class="o-grid o-grid_no-gutter o-grid_demo">
    <div class="o-grid__cell">
        <div class="o-grid-text">first</div>
    </div>
    <div class="o-grid__cell">
        <div class="o-grid-text">second</div>
    </div>
    <div class="o-grid__cell">
        <div class="o-grid-text">third</div>
    </div>
</div>
<div>cell-specific</div>
<div class="o-grid o-grid_demo">
    <div class="o-grid__cell">
        <div class="o-grid-text">first</div>
    </div>
    <div class="o-grid__cell">
        <div class="o-grid-text">second</div>
    </div>
    <div class="o-grid__cell o-grid__cell_no-gutter">
        <div class="o-grid-text">third</div>
    </div>
</div>

*/
/*
Fixed widths

Deprecated: For flexbox grid use Flexbox object. It has much more options and better integration to SEM NEXT UI.
We’ll drop support for these wikis on April 20, 2017.

Usually cells in a grid will be fluid and responsive. If however you want to set a cell to a fixed width add the
\`.o-grid__cell_width-fixed\` modifier and give it a specific width.

markup:
<div class="o-grid o-grid_demo">
    <div class="o-grid__cell">
        <div class="o-grid-text">first</div>
    </div>
    <div class="o-grid__cell o-grid__cell_width-fixed" style="width: 250px">
        <div class="o-grid-text">static width of 250px</div>
    </div>
    <div class="o-grid__cell">
        <div class="o-grid-text">third</div>
    </div>
</div>

*/
/*
Flex-direction

Compatible in IE10+.

By default, just applying the \`.o-grid\` class to a container will cause its children to lay themselves out in a horizontal
row. But we can specify the direction we want children to flow by adding the \`.o-grid_row\` or \`.o-grid_col\` classes to the
container:

\`.o-grid_row\` Lays children out horizontally from right-to-left

\`.o-grid_row_rev\` Lays children out horizontally in the reverse direction (from left-to-right). [must be applied with
class \`.o-grid_row\`]

\`.o-grid_col\` Lays children out vertically from top-to-bottom

\`.o-grid_col_rev\` Lays children out vertically in the reverse direction (from bottom-to-top) [must be applied with class
 \`.o-grid_col\`]

row - Lays children's horizontal flow direction
row_rev - Lays children\`s horizontal flow direction from left-to-right
col - Lays children\`s vertical flow direction
col_rev - Lays children out vertically in the reverse direction (from bottom-to-top)

markup:
<div class="o-grid o-grid_{\$modifiers}">
  <div class="child">
    Child 1
  </div>
  <div class="child">
    Child 2
  </div>
  <div class="child">
    Child 3
  </div>
</div>

*/
/* ==========================================================================
   #GRID RESPONSIVENESS
   ========================================================================== */
/*
Responsiveness

Deprecated: For flexbox grid use Flexbox object. It has much more options and better integration to SEM NEXT UI.
We’ll drop support for these wikis on April 20, 2017.

The grid can be instructed to go full width at certain break points to maximise the screen space and help produce great user experiences on all sorts of devices.

The grid has a fit or full class modifier that is used at different screen sizes.

\`.o-grid_{ small | medium | large }-{ fit | full }\`

The below example will display the cells full width for small and large size screens. For medium screens the cells will
 adjust to fit the available space. Try it out, either resize your browser or rotate your phone into landscape.

markup:
<div class="o-grid o-grid_small-full o-grid_medium-fit o-grid_large-full o-grid_demo">
    <div class="o-grid__cell">
        <div class="o-grid-text">first</div>
    </div>
    <div class="o-grid__cell">
        <div class="o-grid-text">second</div>
    </div>
    <div class="o-grid__cell">
        <div class="o-grid-text">third</div>
    </div>
</div>

*/
/*
Responsive Suffixes

Deprecated: For flexbox grid use Flexbox object. It has much more options and better integration to SEM NEXT UI.
We’ll drop support for these wikis on April 20, 2017.

As well as grid level responsiveness you also have control over the cells within a grid.
Individual cells can change width at specific break points by using responsive suffixes .

As the viewport increases in size the cells go from 100% wide to 33% wide one after another, rather than all at once.

The suffixes apply to the screen sizes and up, in a mobile first manner. In other words:

Set cell width to 33% when screen width is greater than or equal to \`xsmall | small | medium | large | xlarge | super\`

markup:
<div class="o-grid o-grid_wrap o-grid_demo">
    <div class="o-grid__cell o-grid__cell_width-100 o-grid__cell_width-33@small">
        <div class="o-grid-text">small</div>
    </div>
    <div class="o-grid__cell o-grid__cell_width-100 o-grid__cell_width-33@medium">
        <div class="o-grid-text">medium</div>
    </div>
    <div class="o-grid__cell o-grid__cell_width-100 o-grid__cell_width-33@large">
        <div class="o-grid-text">large</div>
    </div>
</div>

*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/* ==========================================================================
   #Image
   ========================================================================== */
/*
Image

Object for easy image placement

markup:
<div class="o-block">
  <div class="o-block__img">
    <img src="http://cdn2.bigcommerce.com/n-biq04i/eir5k/products/229/images/570/Oriental_Sweetlips__95753.1392679931.220.145.jpg?c=2" class="o-image" alt="thmthg" />
  </div>
  <div class="o-block__body">
    This product hasn't received any reviews yet. Be the first to review this product!
  </div>
</div>

*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*

Buttons

markup:
<button class="c-btn">
  Button
</button>

*/
/**
 * 1. Allow us to style box model properties.
 * 2. Line different sized buttons up a little nicer.
 * 3. Make buttons inherit font styles (often necessary when styling \`input\`s as
 *    buttons).
 * 4. Reset/normalize some styles.
 * 5. Force all button-styled elements to appear clickable.
 */
/*
Style variants

bare - Buttons with no styles (good a11y practice to use <button></button> for actions rather than <a></a>)
link - Link buttons
primary - The primary action of the page it is placed on. Place only one primary button on each page/dialog.
secondary - Secondary buttons
tertiary - Tertiary buttons
disabled - Action is disabled. Buttons using this modifier should not be clickable.
active - Active or toggled. Buttons using this modifier should not be clickable.
destroy - A destructive action which can't be undone and might involve loss of data.

markup:
<button class="c-btn c-btn_{\$modifiers}" type="button">
  Button
</button>

*/
/*
Ghost buttons

Ghost buttons have see-through backgrounds and are bordered.

small - small button with small horizontal spacing and tiny vertical spacing.
large - large button with large horizontal spacing and default vertical spacing.
full - Use this modifier to force a button to fill its parent's width.
primary - primary colored button. Use to make accent to action.
secondary - secondary button.
tertiary - tertiary button.

markup:
<button class="c-btn c-btn_ghost c-btn_{\$modifiers}" type="button">
  Button
</button>

*/
/*
Size variants

small - small button with small horizontal spacing and tiny vertical spacing.
large - large button with large horizontal spacing and default vertical spacing.
full - Use this modifier to force a button to fill its parent's width.

markup:
<button type="button" class="c-btn c-btn_{\$modifiers}">
  Button
</button>

*/
/*
Round iconic buttons

markup:
<button class="c-btn c-btn_icon" type="button">
  <span class="fa fa-user"></span>
</button>

*/
/*
Datepicker button

For use in datepicker as datepicker button in calendar.

markup:
<button class="c-btn _c-btn_datepicker" type="button">
  24
</button>

*/
/*
Round iconic buttons

markup:
<button class="c-btn c-btn_menu-toggle" type="button">
  <span class="fa fa-user"></span>
</button>

<button class="c-btn c-btn_border-free" type="button">
  <span class="fa fa-user"></span>
</button>

Styleguide 6.1.1.5
*/
/*
Inline buttons

markup:
<button class="c-btn c-btn_inline" type="button">
  <span class="fa fa-user"></span>
</button>
<button class="c-btn c-btn_inline" type="button">
  <span class="fa fa-calendar"></span>
</button>

*/
/*
Grouped buttons

For use in Button group components

markup:
<button class="c-btn _c-btn_grouped" type="button">
  <span class="fa fa-user"></span>
</button>

*/
/*
Underlined buttons

For use in Tabs as tab labels. To prevent jumping use c-btn_underlined-transparent

markup:
<button class="c-btn c-btn_underlined" type="button">
  <span class="fa fa-user"></span>
</button>

Styleguide 6.1.1.9
*/
/* ==========================================================================
   #BUTTON GROUPS
   ========================================================================== */
/*
Button groups

Actions that logically belong together might be grouped by wrapping them in a container with .c-btn-group.

Each action button must have the modifier class .c-btn_grouped.

Wrap several groups in a .c-btn-group-row to keep them in one line. Each one must have the modifier class  .c-btn-group_in-row.

Please do not use the button group as tabs.

markup:
<div class="c-btn-group">
	<button class="c-btn c-btn_in-btn-group c-btn_large">1</button>
	<button class="c-btn c-btn_in-btn-group c-btn_large">
        <i class="c-icon c-icon_check c-icon_btn c-icon_btn-large"></i>
    </button>
	<button class="c-btn c-btn_in-btn-group c-btn_large">2</button>
	<button class="c-btn c-btn_in-btn-group c-btn_large c-btn_destroy">
        <i class="c-icon c-icon_trash c-icon_btn c-icon_btn-large"></i>
    </button>
</div>

*/
/*
Input groups

Create input groups by using .c-input-group to wrap inputs with the class \`.c-input_in-input-group\`, addons with the
class \`.c-input-addon\` and buttons with the class \`c-btn_grouped\`.

markup:
<label class="c-label" for="priceInput">Addon - Appended</label>
<div class="c-input-group">
	<input class="c-input c-input_in-input-group c-input_text-right" type="text" id="priceInput" placeholder="e. g. 100" />
	<div class="c-input-addon">&euro;</div>
</div>
<label class="c-label" for="urlInput1">Addon - Prepended</label>
<div class="c-input-group">
	<span class="c-input-addon">http://</span>
	<input class="c-input c-input_in-input-group" type="text" id="urlInput1" placeholder="e. g. brands.zalando.com" />
</div>
<label class="c-label" for="urlInput2">Button - Appended</label>
<div class="c-input-group">
	<input class="c-input c-input_in-input-group" type="text" id="urlInput2" placeholder="e. g. brands.zalando.com" />
	<button class="c-btn c-btn_in-input-group c-btn_primary">
      <i class="c-icon c-icon_search c-icon_btn fa fa-search"></i>
  </button>
</div>
<label class="c-label" for="userInput">Addon - Prepended & Button - Appended</label>
<div class="c-input-group">
	<span class="c-input-addon">User 1</span>
	<input class="c-input c-input_in-input-group" type="text" id="userInput" placeholder="Full name" />
	<button class="c-btn c-btn_in-input-group c-btn_primary">Add</button>
</div>

*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Label for input

Label styling is based on .c-label class and it\`s modifiers and elements.

There are two possible ways to combine label and input into form field.

markup:
<form class="c-form">
  <h4>Variant 1 - Stacked input and label. Use of \`id\` on input and \`for\` attribut on label is recommended.
  This variant is usefull when using grid based form (see below).</h4>
  <div class="c-form-group">
    <div class="c-form-field">
      <label class="c-label" for="input2">Input Label</label>
      <input id="input2" placeholder="Type something..." class="c-input c-input_small" type="text">
    </div>
  </div>
</form>
<form class="c-form">
  <h4>Variant 2 - Input wrapped into label. \`id\` and \`for\` attributs may be omitted.</h4>
  <p>Keep in mind, that this is much less accessible input.</p>
  <div class="c-form-group">
    <label class="c-label" for="input222">
      <span class="c-label__content">Input Label</span>
      <input class="c-input c-input_small" type="text" id="input222" placeholder="Type something...">
    </label>
  </div>
</form>

*/
/*
Sub-label

Use it for secondary description.

markup:
<label class="c-label" for="numberInput11">
    Input label
    <span class="c-label__sub">input sub-label</span>
</label>
<input class="c-input" type="text" id="numberInput11" placeholder="Type something">

*/
/*
Sub-label validation statuses

c-label__sub_is-success - Success input style
c-label__sub_is-warning - Warning input style
c-label__sub_is-error - Error input style

markup:
<label class="c-label" for="numberInput1">
    Input label
    <span class="c-label__sub {\$modifiers}">input sub-label</span>
</label>
<div class="c-form-field">
  <input class="c-input" type="text" id="numberInput1" placeholder="Type something">
  <label class="c-label">
    <div class="c-label__content">
    Input Label
    <span class="c-label__sub {\$modifiers}">input sub-label</span>
    </div>
    <input placeholder="Type something..." class="c-input c-input_small" type="text">
  </label>
</div>

*/
/*
Disabled label

markup:
<label class="c-label c-label_disabled" for="numberInput2">
    <div class="c-label__content">
      Input label disabled
      <span class="c-label__sub">input sub-label</span>
    </div>
</label>
<div class="c-form-field">
  <input class="c-input" type="text" id="numberInput2" placeholder="Type something">
  <label class="c-label c-label_disabled">
    <div class="c-label__content">
    Input label disabled (v2)
    <span class="c-label__sub">input sub-label</span>
    </div>
    <input placeholder="Type something..." class="c-input c-input_small" type="text">
  </label>
</div>

*/
/*
Label validation statuses

c-label_is-success - success state
c-label_is-warning - warning state
c-label_is-error - error state

markup:
<label class="c-label {\$modifiers}" for="numberInput3">
  <div class="c-label__content">
    Input label with status
    <span class="c-label__sub">input sub-label</span>
  </div>
</label>
<div class="c-form-field">
  <input class="c-input" type="text" id="numberInput3" placeholder="Type something">
  <label class="c-label {\$modifiers}">
    <div class="c-label__content">
    Input label with status (v2)
    <span class="c-label__sub">input sub-label</span>
    </div>
    <input placeholder="Type something..." class="c-input c-input_small" type="text">
  </label>
</div>

*/
/*
Required label

Along with making a field actually required, you can add a visual clue for the users using a
\`<span class="c-label__req">*</span>\` inside c-label__content element.

markup:
<form class="c-form">
  <div class="c-form-group">
    <div class="c-form-field">
      <label class="c-label" for="input2123">
        <span class="c-label_content c-label__content_required">Input Label</span>
        <span class="c-label__req">*</span>
        <span class="c-label__sub">input sub-label</span>
      </label>
      <input class="c-input c-input_small" type="text" id="input2123" placeholder="Type something...">
    </div>
  </div>
</form>
<form class="c-form">
  <div class="c-form-group">
    <label class="c-label">
      <span class="c-label__content">
        Input Label
        <span class="c-label__req">*</span>
        <span class="c-label__sub">input sub-label</span>
      </span>
      <input class="c-input c-input_small" type="text" placeholder="Type something...">
    </label>
  </div>
</form>

*/
/*
Inline label content

For use in inline form-groups.

markup:
<form class="c-form">
  <div class="c-form-group">
    <div class="c-form-field">
      <label class="c-label" for="input2123">
        <span class="c-label__content c-label__content_inline">Inline Input Label</span>
      </label>
      <input class="c-input c-input_small" type="text" id="input2123" placeholder="Type something...">
    </div>
  </div>
</form>
<form class="c-form">
  <div class="c-form-group">
    <label class="c-label">
      <span class="c-label__content c-label__content_inline">
        Input Label
      </span>
      <input class="c-input c-input_small" type="text" placeholder="Type something...">
    </label>
  </div>
</form>

*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Lists

Non-styled list example

markup:
<p>Defaul list</p>
<ul>
  <li>list item 1</li>
  <li>list item 2</li>
  <li>list item 3</li>
</ul>

*/
/*
Default List

\`.o-list\` class

markup:
<p>Default List</p>
<ul class="o-list">
  <li>list item 1</li>
  <li>list item 2</li>
  <li>list item 3</li>
</ul>

*/
/*
List-bare

Strip list-like appearance from lists by removing their bullets, and any indentation.

markup:
<p>List-bare</p>
<ul class="o-list-bare">
  <li>list item 1</li>
  <li>list item 2</li>
  <li>list item 3</li>
</ul>

*/
/*
List-inline

The list-inline object simply displays a list of items in one line.

markup:
<p>List-inline</p>
<ul class="o-list-inline">
  <li class="o-list-inline o-list-inline__item">list item 1</li>
  <li class="o-list-inline o-list-inline__item">list item 2</li>
  <li class="o-list-inline o-list-inline__item">list item 3</li>
</ul>

*/
/*
Delimited list

By default, applying this class will comma separate your list items. You can change the delimiter by predefining the
following variable:

\$list-inline-delimiter

markup:
<p>List-delimited</p>
<ul class="o-list-inline o-list-inline_delimited">
  <li class="o-list-inline o-list-inline__item">list item 1</li>
  <li class="o-list-inline o-list-inline__item">list item 2</li>
  <li class="o-list-inline o-list-inline__item">list item 3</li>
</ul>

*/
/**
 * 1. Fallback for old IEs not supporting \`rem\` values.
 */
/*
Ordered list

markup:
<p>Ordered and unordered lists</p>
<ul class="o-list o-list_ordered">
  <li>list item 1</li>
  <li>list item 2</li>
  <li>list item 3</li>
</ul>
<ul class="o-list o-list_unordered">
  <li>list item 1</li>
  <li>list item 2</li>
  <li>list item 3</li>
</ul>

*/
/*
Scrollable list

markup:
<p>Scrollable list</p>
<ul class="c-list c-list_is-scrollable">
  <li>list item 1</li>
  <li>list item 2</li>
  <li>list item 3</li>
  <li>list item 4</li>
  <li>list item 5</li>
  <li>list item 6</li>
  <li>list item 7</li>
  <li>list item 8</li>
  <li>list item 9</li>
  <li>list item 10</li>
  <li>list item 11</li>
  <li>list item 12</li>
  <li>list item 13</li>
  <li>list item 14</li>
  <li>list item 15</li>
  <li>list item 16</li>
  <li>list item 17</li>
  <li>list item 18</li>
</ul>
*/
/*
Interactive list-items

Adding .c-list__item_is-interactive to the list-item makes it highlighted on focus.

markup:
<p>Scrollable list</p>
<ul class="c-list">
  <li class="c-list__item c-list__item_is-interactive">list item 1</li>
  <li class="c-list__item c-list__item_is-interactive">list item 2</li>
  <li class="c-list__item c-list__item_is-interactive">list item 3</li>
  <li class="c-list__item c-list__item_is-interactive">list item 4</li>
  <li class="c-list__item c-list__item_is-interactive">list item 5</li>
  <li class="c-list__item c-list__item_is-interactive">list item 6</li>
  <li class="c-list__item c-list__item_is-interactive">list item 7</li>
  <li class="c-list__item c-list__item_is-interactive">list item 8</li>
</ul>

*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/* ==========================================================================
   #LIST-GROUPS
   ========================================================================== */
/*
List-groups
*/
/*
List-groups base class

Easily usable on \`<ul>\`, \`<ol>\`, or \`<div>\`.

markup:
<p>Base list-group</p>
<ul class="c-list-group">
  <li class="c-list-group__item">1</li>
  <li class="c-list-group__item">2</li>
  <li class="c-list-group__item">3</li>
  <li class="c-list-group__item">4</li>
</ul>

*/
/*
Interactive list items

Use anchor or button elements instead of \`li\`s or \`div\`s to create interactive
 list items. Includes an extra \`.active\` modifier class for selected items.

markup:
<p>Base list-group</p>
<ul class="c-list-group">
  <li class="c-list-group__item c-list-group__item_is-interactive">123</li>
  <li class="c-list-group__item c-list-group__item_is-interactive">123</li>
  <li class="c-list-group__item c-list-group__item_is-interactive">123</li>
  <li class="c-list-group__item c-list-group__item_is-interactive">123</li>
</ul>

*/
/*
Individual list items

Use on \`li\`s or \`div\`s within the \`.list-group\` parent.

markup:
<p>Base list-group</p>
<ul class="c-list-group">
  <li class="c-list-group__item">123</li>
  <li class="c-list-group__item">123</li>
  <li class="c-list-group__item">123</li>
  <li class="c-list-group__item">123</li>
</ul>

*/
/*
Flush list items

Remove borders and border-radius to keep list group items edge-to-edge. Most useful within other components (e.g., cards,
panels).

markup:
<p>Flush list-group</p>
<ul class="c-list-group c-list-group_flush">
  <li class="c-list-group__item">123</li>
  <li class="c-list-group__item">123</li>
  <li class="c-list-group__item">123</li>
  <li class="c-list-group__item">123</li>
</ul>

*/
/*
Contextual variants

Add modifier classes to change text and background color on individual items.
Organizationally, this must come after the \`:hover\` states.

markup:
<p>Flush list-group</p>
<ul class="c-list-group">
  <li class="c-list-group__item c-list-group__item_success">success</li>
  <li class="c-list-group__item c-list-group__item_info">info</li>
  <li class="c-list-group__item c-list-group__item_warning">warning</li>
  <li class="c-list-group__item c-list-group__item_error">error</li>
  <li class="c-list-group__item c-list-group__item_critical">critical</li>
</ul>

*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Navbar

markup:
<header class="c-navbar c-navbar_default u-hidden-print" ng-controller="CollapseDemoCtrl">
    <div class="c-navbar__header">
        <a class="c-navbar__brand" > <img class="o-image" src="https://unsplash.it/g/500/200?random" alt="Company logo"></a>
        <!--<span class="c-nav__content u-window-box--none">
            <img class="o-image" src="https://unsplash.it/500/200">
        </span> -->
        <!--<a class="c-navbar__brand c-navbar-brand-collapsed" ui-sref="app.dashboard" href="#/app/dashboard"> <img ng-src="assets/images/logo-collapsed2.png" alt="" src="assets/images/logo-collapsed2.png"> </a>-->
        <!-- start: MENU TOGGLER FOR MOBILE DEVICES -->
         <!-- <div class="close-handle visible-xs-block menu-toggler" ng-click="isNavCollapsed = !isNavCollapsed" ng-swipe-up="navbarCollapsed = true">
          <span class="sr-only">Toggle navigation</span>
          <span class="fa fa-bars"></span>
        </div>-->
        <button type="button" class="c-navbar__toggle" ng-click="isNavCollapsed = !isNavCollapsed" ng-swipe-up="navbarCollapsed = true">
          <span class="sr-only">Toggle navigation</span>
          <span class="fa fa-ellipsis-h"></span>
        </button>
        <!-- end: MENU TOGGLER FOR MOBILE DEVICES -->
    </div>
    <div class="c-navbar__collapse" uib-collapse="isNavCollapsed">
        <ul class="c-navbar__nav c-navbar__right" ng-controller="NavbarCtrl">
            <li class="c-navbar__nav-listitem c-dropdown">
                <a href="" class="c-navbar__nav-content" data-toggle="dropdown"> <span class="badge"> 3 </span> <i class="fa fa-envelope"></i> </a>
            </li>
            <li class="c-navbar__nav-listitem c-dropdown" uib-dropdown>
              <a href id="lang-choose" class="c-navbar__nav-content" uib-dropdown-toggle>
                <i class="flag-icon flag-icon-us"></i> English <span class="c-caret"></span>
              </a>
              <ul class="c-dropdown-menu c-dropdown-menu_right" uib-dropdown-menu role="menu" aria-labelledby="lang-choose">
                <li class="c-dropdown-menu__listitem" role="menuitem" ng-repeat="lang in items">
                    <a href="#" class="c-dropdown-menu__content" ng-click="setLanguage('ru')">{{lang}}</a>
                </li>
              </ul>
            </li>
        </ul>
    </div>
</header>

sg-wrapper:
<div class="sg sg-box-lg">
  <sg-wrapper-content/>
</div>

 */
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/* ==========================================================================
   #Panels
   ========================================================================== */
/*
Panels

A panel can be a very useful piece of layout, it provides a manageable scrollable space within the existing structure of
your page.

markup:
<div class="o-panel-container" style="height: 350px">
  <div class="o-panel">
    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam eget neque mollis, sodales nulla ut, porta
    urna.
  </div>
</div>

*/
/*
Panels container heights

\`.o-panel-container_height-small\` - 250px
\`.o-panel-container_height-middle\` - 350px
\`.o-panel-container_height-large\` - 450px

markup:
<h5>Small Panel Container</h5>
<div class="o-panel-container o-panel-container_height-small">
  <div class="o-panel">
    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam eget neque mollis, sodales nulla ut, porta
    urna.
  </div>
</div>
<h5>Middle Panel Container</h5>
<div class="o-panel-container o-panel-container_height-middle">
  <div class="o-panel">
    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam eget neque mollis, sodales nulla ut, porta
    urna.
  </div>
</div>
<h5>Large Panel Container</h5>
<div class="o-panel-container o-panel-container_height-large">
  <div class="o-panel">
    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam eget neque mollis, sodales nulla ut, porta
    urna. Vivamus gravida placerat metus ac malesuada. Donec convallis dolor in ex tristique, luctus tempus dui
    sollicitudin.
  </div>
</div>

*/
/*
Panels

Panels are the basic building blocks of a page. Usually all content should be inside one or more card. For example,
in this demo, every section or element is inside a card. We don't recommend nesting cards, such as in this example,
but it's technically possible.

markup:
<div class="c-panel">
  <div class="c-panel__heading">Header</div>
  <div class="c-panel__body">Body with content</div>
  <div class="c-panel__footer">Footer</div>
</div>

*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Radio button

markup:
<label class="c-radio">
  <input type="radio" class="c-radio__input" name="r1">
  <i class="c-radio__icon"></i>
  <span class="c-radio__label">Check this</span>
</label>
<label class="c-radio">
  <input type="radio" class="c-radio__input" name="r1" checked>
  <i class="c-radio__icon"></i>
  <span class="c-radio__label">Check that</span>
</label>
<label class="c-radio">
  <input type="radio" class="c-radio__input" name="r2" disabled >
  <i class="c-radio__icon"></i>
  <span class="c-radio__label">Check Disabled</span>
</label>
<label class="c-radio">
  <input type="radio" class="c-radio__input" name="r2" checked disabled >
  <i class="c-radio__icon"></i>
  <span class="c-radio__label">Check Disabled</span>
</label>

*/
/*
Inline Radio

Group radiobuttons on the same horizontal row by adding \`.c-radio_inline\` to any \`.c-radio\`.

markup:
<label class="c-radio c-radio_inline">
  <input type="radio" class="c-radio__input" name="rig1">
  <i class="c-radio__icon"></i>
  <span class="c-radio__label">Check this</span>
</label>
<label class="c-radio c-radio_inline">
  <input type="radio" class="c-radio__input" disabled name="rig1">
  <i class="c-radio__icon"></i>
  <span class="c-radio__label">Check Disabled</span>
</label>
<label class="c-radio c-radio_switch c-radio_inline">
  <input type="radio" class="c-radio__input" checked name="rig1">
  <i class="c-radio__icon"></i>
  <span class="c-radio__label">Check that</span>
</label>
<label class="c-radio c-radio_switch c-radio_inline">
  <input type="radio" class="c-radio__input" checked name="rig1">
  <i class="c-radio__icon"></i>
  <span class="c-radio__label">Check that</span>
</label>

*/
/*
Radio with custom label

You can customize label view and even hide label. Just wrap it with \`.c-radio__label\` span.

To hide label use \`sr-only\` class on \`.c-radio__label\` element. Do not remove label from html.

markup:
<label class="c-radio">
  <input class="c-radio__input" type="radio">
  <i class="c-radio__icon"></i>
  <span class="c-radio__label">Radio with custom label</span>
</label>
<label class="c-radio">
  <input class="c-radio__input" type="radio">
  <i class="c-radio__icon"></i>
  <span class="c-radio__label sr-only">Radio with custom label</span>
</label>

*/
/* ==========================================================================
   #RATIO
   ========================================================================== */
/*
Ratio

Create ratio-bound content blocks, to keep media (e.g. images, videos) in their correct aspect ratios.

 http://alistapart.com/article/creating-intrinsic-ratios-for-video

1. Default cropping is a 1:1 ratio (i.e. a perfect square).

markup:
<div>Default ratio object (1:1)</div>
<div class="o-ratio">
  <div class="o-ratio__content" style="background: #ccc;">
    <img src="http://www.uniwallpaper.com/static/images/6890733-mountain-peaks-wallpaper-hd_PZTQDff.jpg" alt="thmthg" style="max-width: none; max-height: 100%;/>
  </div>
</div>
<div>16:9 object</div>
<div class="o-ratio o-ratio_16:9">
  <iframe width="560" height="315" src="https://www.youtube.com/embed/y_NjiRiMWRM" frameborder="0" allowfullscreen></iframe>
</div>

Styleguide 5.9
*/
/**
 * Create ratio-bound content blocks, to keep media (e.g. images, videos) in
 * their correct aspect ratios.
 *
 * http://alistapart.com/article/creating-intrinsic-ratios-for-video
 *
 * 1. Default cropping is a 1:1 ratio (i.e. a perfect square).
 */
/* stylelint-disable */
/* Ratio variants.
   ========================================================================== */
/**
 * Generate a series of ratio classes to be used like so:
 *
 *   <div class="o-ratio  o-ratio_16:9">
 *
 */
/* stylelint-enable */
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Input

Input styling based on \`.c-input\` block class and it\`s modifiers.

*/
/*
Input

markup:
<input class="c-input" id="input1" placeholder="Text Input" type="text">
<input class="c-input" id="input2" placeholder="Readonly Input" type="text" readonly value="Unchangeble info">
<input class="c-input" id="input3" placeholder="Disabled Input" type="text" disabled>
<input class="c-input" id="input4" placeholder="Input type='email'" type="email">
<input class="c-input" id="input5" placeholder="Input type='tel'" type="tel">
<input class="c-input" id="input6" placeholder="Input type='search'" type="search">
<input class="c-input" id="input7" placeholder="Input type='number'" type="number">
<input class="c-input" id="input8" placeholder="Input type='date'" type="date">

*/
/*
Input Block

Input on full width of it\`s parent.

markup:
<input id="input1" placeholder="Full width of parent container" class="c-input c-input_block" type="text">

*/
/*
Input Text Right

Text right aligning inside input.

markup:
<input class="c-input c-input_text-right" placeholder="Type something..." type="text">

*/
/*
Input Length

c-input_xtiny - xtiny length (88px)
c-input_tiny - tiny length (106px)
c-input_small - small  length
c-input_regular - regular length
c-input_large - large length
c-input_huge - huge length

markup:
<input class="c-input {\$modifiers}" placeholder="Input length {\$modifiers}" type="text">

*/
/*
Bare Input

markup:
<input class="c-input c-input_bare" placeholder="Type something..." type="text">

*/
/**
 * Text inputs with no styles.
 */
/*
Input Validation

c-input_is-success - Success input style
c-input_is-warning - Warning input style
c-input_is-error - Error input style

markup:
<input class="c-input {\$modifiers}" placeholder="Validation class .{\$modifiers}" type="text">

*/
/**
 * Styles for validation states
 */
/*
Select

markup:
<select class="c-select" name="" id="">
	<option value="">Enabled</option>
	<option value="">Option 2</option>
	<option value="">Option 3</option>
	<option value="">Option 4</option>
	<option value="">Option 5</option>
</select>
<select class="c-select" disabled="" name="" id="">
	<option value="">Disabled</option>
	<option value="">Option 2</option>
	<option value="">Option 3</option>
	<option value="">Option 4</option>
	<option value="">Option 5</option>
</select>

*/
/*
Select small

To match radio & checkbox.

markup:
<select class="c-select c-select_small" name="" id="">
	<option value="">Enabled</option>
	<option value="">Option 2</option>
	<option value="">Option 3</option>
	<option value="">Option 4</option>
	<option value="">Option 5</option>
</select>

*/
/*
Select statuses

Select with validation status.

markup:
<select class="c-select c-select_is-success" name="" id="">
	<option value="">Enabled</option>
	<option value="">Option 2</option>
	<option value="">Option 3</option>
	<option value="">Option 4</option>
	<option value="">Option 5</option>
</select>
<select class="c-select c-select_is-warning" name="" id="">
	<option value="">Enabled</option>
	<option value="">Option 2</option>
	<option value="">Option 3</option>
	<option value="">Option 4</option>
	<option value="">Option 5</option>
</select>
<select class="c-select c-select_is-error" name="" id="">
	<option value="">Enabled</option>
	<option value="">Option 2</option>
	<option value="">Option 3</option>
	<option value="">Option 4</option>
	<option value="">Option 5</option>
</select>

*/
/*
Select full width

Select with validation status.

markup:
<select class="c-select c-select_block">
	<option value="">Enabled</option>
	<option value="">Option 2</option>
	<option value="">Option 3</option>
	<option value="">Option 4</option>
	<option value="">Option 5</option>
</select>

*/
/*
Divider for select

Divider may be created as option. See below:
\`<option value="" disabled="disabled" role="separator">─────────────────────────</option>\`

markup:
<select class="c-select">
	<option value="">Enabled</option>
	<option value="" disabled="disabled" role="separator">─────────────────────────</option>
	<option value="">Option 3</option>
	<option value="">Option 4</option>
	<option value="">Option 5</option>
</select>

*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Static control

When you need to place plain text next to a form label within a form, use the .form-control-static class on an element
of your choice.

markup:
<form class="c-form">
  <div class="c-form-group">
    <label class="c-label">E-mail</label>
    <p class="c-static">email@example.com</p>
  </div>
  <div class="c-form-group">
    <label class="c-label">
      <div class="c-label__content">layout variant</div>
      <p class="c-static">2</p>
    </label>
  </div>
  <div class="c-form-group">
    <label class="c-label" for="inputfls2" >Readonly Input</label>
    <input class="c-input" id="inputfls2" placeholder="Type something..." type="text" readonly value="Unchangeble info">
  </div>
</form>

Styleguide 6.1.3.7
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Input

Input styling based on \`.c-input\` block class and it\`s modifiers.

*/
/*
Input

markup:
<input class="c-input" id="input1" placeholder="Text Input" type="text">
<input class="c-input" id="input2" placeholder="Readonly Input" type="text" readonly value="Unchangeble info">
<input class="c-input" id="input3" placeholder="Disabled Input" type="text" disabled>
<input class="c-input" id="input4" placeholder="Input type='email'" type="email">
<input class="c-input" id="input5" placeholder="Input type='tel'" type="tel">
<input class="c-input" id="input6" placeholder="Input type='search'" type="search">
<input class="c-input" id="input7" placeholder="Input type='number'" type="number">
<input class="c-input" id="input8" placeholder="Input type='date'" type="date">

*/
/*
Input Block

Input on full width of it\`s parent.

markup:
<input id="input1" placeholder="Full width of parent container" class="c-input c-input_block" type="text">

*/
/*
Input Text Right

Text right aligning inside input.

markup:
<input class="c-input c-input_text-right" placeholder="Type something..." type="text">

*/
/*
Input Length

c-input_xtiny - xtiny length (88px)
c-input_tiny - tiny length (106px)
c-input_small - small  length
c-input_regular - regular length
c-input_large - large length
c-input_huge - huge length

markup:
<input class="c-input {\$modifiers}" placeholder="Input length {\$modifiers}" type="text">

*/
/*
Bare Input

markup:
<input class="c-input c-input_bare" placeholder="Type something..." type="text">

*/
/**
 * Text inputs with no styles.
 */
/*
Input Validation

c-input_is-success - Success input style
c-input_is-warning - Warning input style
c-input_is-error - Error input style

markup:
<input class="c-input {\$modifiers}" placeholder="Validation class .{\$modifiers}" type="text">

*/
/**
 * Styles for validation states
 */
/*
Textarea

markup:
<label class="c-label" for="textArea">Text area</label>
<textarea class="c-textarea" name="textArea" id="" cols="30" rows="5"></textarea>
<label class="c-label" for="textAreaV2">
  <div class="c-label__content">Text area (v2)</div>
  <textarea class="c-textarea" name="textAreaV2" id="" cols="30" rows="5"></textarea>
</label>
<label class="c-label" for="textAreaDisabled">Disabled text area</label>
<textarea class="c-textarea" name="textAreaDisabled" id="" cols="30" rows="5" disabled></textarea>

*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Tooltip

A tooltip provides a short description of a UI element.

\`.c-tooltip\`

This class wraps an actionable icon followed by the .c-tooltip__content to be shown on the icon. The content appears when the user hovers over the icon.

\`.c-tooltip__content\`

This class contains the text that will be shown when the tooltip is visible.

- Use a verb phrase to describe the action on the icon, for example, “Edit settings.”
- Use only plain text and be concise. Tooltips can be a sentence fragment.
- If more detailed information is required, use another form of help.
- Use sentence-style caps and no ending punctuation.

markup:
<div class="o-box o-box_large">
  <a href="#" role="tooltip" aria-haspopup="true" class="c-tooltip">
      <span class="fa fa-calendar"></span>
      <span class="c-tooltip__content">Tooltip content</span>
  </a>
</div>

*/
/*
Tooltip directions

Tooltips support six directions, defined by using one of the following classes with the \`.c-tooltip\` class:
- \`.c-tooltip_top-right\`
- \`.c-tooltip_top-left\`
- \`.c-tooltip_bottom-right\`
- \`.c-tooltip_bottom-left\`
- \`.c-tooltip_right\`
- \`.c-tooltip_left\`

markup:
<div class="o-grid o-grid_wrap">
	<div class="o-grid__cell o-grid__cell_width-33 o-box">
	  <a href="#" role="tooltip" aria-haspopup="true" class="c-tooltip c-tooltip_bottom-right">
      Bottom-right
      <span class="c-tooltip__content">Tooltip content</span>
    </a>
	</div>
	<div class="o-grid__cell o-grid__cell_width-33 o-box">
	  <a href="#" role="tooltip" aria-haspopup="true" class="c-tooltip c-tooltip_bottom">
      Bottom
      <span class="c-tooltip__content">Tooltip content</span>
    </a>
	</div>
	<div class="o-grid__cell o-grid__cell_width-33 o-box">
	  <a href="#" role="tooltip" aria-haspopup="true" class="c-tooltip c-tooltip_bottom-left">
      Bottom-left
      <span class="c-tooltip__content">Tooltip content</span>
    </a>
	</div>
	<div class="o-grid__cell o-grid__cell_width-33 o-box">
	  <a href="#" role="tooltip" aria-haspopup="true" class="c-tooltip c-tooltip_right">
      Right
      <span class="c-tooltip__content">Tooltip content</span>
    </a>
	</div>
	<div class="o-grid__cell o-grid__cell_width-33 o-box">
	  <div>
      No tooltip
    </div>
	</div>
	<div class="o-grid__cell o-grid__cell_width-33 o-box">
	  <a href="#" role="tooltip" aria-haspopup="true" class="c-tooltip c-tooltip_left">
      Left
      <span class="c-tooltip__content">Tooltip content</span>
    </a>
	</div>
	<div class="o-grid__cell o-grid__cell_width-33 o-box">
	  <a href="#" role="tooltip" aria-haspopup="true" class="c-tooltip c-tooltip_top-right">
      Top-right
      <span class="c-tooltip__content">Tooltip content</span>
    </a>
	</div>
	<div class="o-grid__cell o-grid__cell_width-33 o-box">
	  <a href="#" role="tooltip" aria-haspopup="true" class="c-tooltip c-tooltip_top">
      Top
      <span class="c-tooltip__content">Tooltip content</span>
    </a>
	</div>
	<div class="o-grid__cell o-grid__cell_width-33 o-box">
	  <a href="#" role="tooltip" aria-haspopup="true" class="c-tooltip c-tooltip_top-left">
      Top-left
      <span class="c-tooltip__content">Tooltip content</span>
    </a>
	</div>
</div>

*/
/*
Tooltip sizes

Set a width that accommodates the text string. The default is 240 px. Other choices are 72 px, 120 px, and 360 px.
- \`.c-tooltip_xs\` - 72px,
- \`.c-tooltip_sm\` - 120px,
- \`.c-tooltip_lg\` - 360px

markup:
<div class="o-box o-box_large">
  <button class="c-btn c-tooltip c-tooltip_xs" role="tooltip" aria-haspopup="true">
  	xsmall
  	<span class="c-tooltip__content">width = 72px</span>
  </button>
  <button class="c-btn c-tooltip c-tooltip_sm" role="tooltip" aria-haspopup="true">
  	small
  	<span class="c-tooltip__content">width = 120px</span>
  </button>
  <button class="c-btn c-tooltip" role="tooltip" aria-haspopup="true">
  	default
  	<span class="c-tooltip__content">width = 240px</span>
  </button>
  <button class="c-btn c-tooltip c-tooltip_lg" role="tooltip" aria-haspopup="true">
  	large
  	<span class="c-tooltip__content">width = 360px</span>
  </button>
</div>

*/
/*
Tooltip-based validation messages

Works on both field layouts. Instead of default tooltip validation tooltip fires on \`:focus\` event.

Top, top-left and top-right tooltip variants are preferred.

markup:
<form class="c-form c-form_compact">
  <div class="c-form-group">
    <div class="c-form-field c-tooltip c-tooltip_validation c-tooltip_top-right is-tooltip-validation_invalid">
      <label class="c-label" for="inputflc12" >Input-label siblings layout</label>
      <input class="c-input c-input_is-error" id="inputflc12" placeholder="Type something..." type="text">
      <span class="c-tooltip__content">Invalid content in field</span>
    </div>
  </div>
  <div class="c-form-group">
    <label class="c-label c-tooltip c-tooltip_validation c-tooltip_top-right is-tooltip-validation_invalid">
      <span class="c-label__content">Input wrapped with label layout</span>
      <input class="c-input c-input_is-error c-input_block" type="text" placeholder="Type something...">
      <span class="c-tooltip__content">Invalid content in field</span>
    </label>
  </div>
  <div class="c-form-group">
    <div class="c-form-field c-tooltip c-tooltip_validation c-tooltip_bottom-right is-tooltip-validation_invalid">
      <label class="c-label" for="inputflc12" >Input-label siblings layout</label>
      <input class="c-input c-input_is-error" id="inputflc12" placeholder="Type something..." type="text">
      <span class="c-tooltip__content">Invalid content in field</span>
    </div>
  </div>
  <div class="c-form-group">
    <label class="c-label c-tooltip c-tooltip_validation c-tooltip_bottom-right is-tooltip-validation_invalid">
      <span class="c-label__content">Input wrapped with label layout</span>
      <input class="c-input c-input_is-error c-input_block" type="text" placeholder="Type something...">
      <span class="c-tooltip__content">Invalid content in field</span>
    </label>
  </div>
  <div class="c-form-group">
    <label class="c-checkbox c-checkbox_inline">
      <input type="checkbox" class="c-checkbox__input">
      <i class="c-checkbox__icon"></i>
      <span class="c-checkbox__label">Check this</span>
    </label>
    <label class="c-checkbox c-checkbox_inline">
      <input type="checkbox" class="c-checkbox__input">
      <i class="c-checkbox__icon"></i>
      <span class="c-checkbox__label">Check this</span>
    </label>
  </div>
  <div class="o-grid o-grid_wrap">
    <div class="o-grid__cell o-grid__cell_width-33 o-box">
      <div class="c-form-group">
        <div class="c-form-field c-tooltip c-tooltip_validation c-tooltip_bottom-right is-tooltip-validation_invalid">
          <label class="c-label" for="inputflc1233" >Tooltip at</label>
          <input class="c-input c-input_is-error" id="inputflc1233" placeholder="bottom-right" type="text">
          <span class="c-tooltip__content">Invalid content in field</span>
        </div>
      </div>
      <div class="c-form-group">
        <label class="c-label c-tooltip c-tooltip_validation c-tooltip_bottom-right is-tooltip-validation_invalid">
          <span class="c-label__content">Tooltip at</span>
          <input class="c-input c-input_is-error c-input_small" type="text" placeholder="bottom-right">
          <span class="c-tooltip__content">Invalid content in field</span>
        </label>
      </div>
    </div>
    <div class="o-grid__cell o-grid__cell_width-33 o-box">
      <div class="c-form-group">
        <div class="c-form-field c-tooltip c-tooltip_validation c-tooltip_bottom is-tooltip-validation_invalid">
          <label class="c-label" for="inputflc1234" >Tooltip at</label>
          <input class="c-input c-input_is-error" id="inputflc1234" placeholder="bottom" type="text">
          <span class="c-tooltip__content">Invalid content in field</span>
        </div>
      </div>
      <div class="c-form-group">
        <label class="c-label c-tooltip c-tooltip_validation c-tooltip_bottom is-tooltip-validation_invalid">
          <span class="c-label__content">Tooltip at</span>
          <input class="c-input c-input_is-error c-input_small" type="text" placeholder="bottom">
          <span class="c-tooltip__content">Invalid content in field</span>
        </label>
      </div>
    </div>
    <div class="o-grid__cell o-grid__cell_width-33 o-box">
      <div class="c-form-group">
        <div class="c-form-field c-tooltip c-tooltip_validation c-tooltip_bottom-left is-tooltip-validation_invalid">
          <label class="c-label" for="inputflc1235" >Tooltip at</label>
          <input class="c-input c-input_is-error" id="inputflc1235" placeholder="bottom-left" type="text">
          <span class="c-tooltip__content">Invalid content in field</span>
        </div>
      </div>
      <div class="c-form-group">
        <label class="c-label c-tooltip c-tooltip_validation c-tooltip_bottom-left is-tooltip-validation_invalid">
          <span class="c-label__content">Tooltip at</span>
          <input class="c-input c-input_is-error c-input_small" type="text" placeholder="bottom-left">
          <span class="c-tooltip__content">Invalid content in field</span>
        </label>
      </div>
    </div>
    <div class="o-grid__cell o-grid__cell_width-33 o-box">
      <div class="c-form-group">
        <div class="c-form-field c-tooltip c-tooltip_validation c-tooltip_right is-tooltip-validation_invalid">
          <label class="c-label" for="inputflc1236" >Tooltip at</label>
          <input class="c-input c-input_is-error" id="inputflc1236" placeholder="right" type="text">
          <span class="c-tooltip__content">Invalid content in field</span>
        </div>
      </div>
      <div class="c-form-group">
        <label class="c-label c-tooltip c-tooltip_validation c-tooltip_right is-tooltip-validation_invalid">
          <span class="c-label__content">Tooltip at</span>
          <input class="c-input c-input_is-error c-input_small" type="text" placeholder="right">
          <span class="c-tooltip__content">Invalid content in field</span>
        </label>
      </div>
    </div>
    <div class="o-grid__cell o-grid__cell_width-33 o-box">
      <div>
        No tooltip
      </div>
    </div>
    <div class="o-grid__cell o-grid__cell_width-33 o-box">
      <div class="c-form-group">
        <div class="c-form-field c-tooltip c-tooltip_validation c-tooltip_left is-tooltip-validation_invalid">
          <label class="c-label" for="inputflc1237" >Tooltip at</label>
          <input class="c-input c-input_is-error" id="inputflc1237" placeholder="left" type="text">
          <span class="c-tooltip__content">Invalid content in field</span>
        </div>
      </div>
      <div class="c-form-group">
        <label class="c-label c-tooltip c-tooltip_validation c-tooltip_left is-tooltip-validation_invalid">
          <span class="c-label__content">Tooltip at</span>
          <input class="c-input c-input_is-error c-input_small" type="text" placeholder="left">
          <span class="c-tooltip__content">Invalid content in field</span>
        </label>
      </div>
    </div>
    <div class="o-grid__cell o-grid__cell_width-33 o-box">
      <div class="c-form-group">
        <div class="c-form-field c-tooltip c-tooltip_validation c-tooltip_top-right is-tooltip-validation_invalid">
          <label class="c-label" for="inputflc1238" >Tooltip at</label>
          <input class="c-input c-input_is-error" id="inputflc1238" placeholder="top-right" type="text">
          <span class="c-tooltip__content">Invalid content in field</span>
        </div>
      </div>
      <div class="c-form-group">
        <label class="c-label c-tooltip c-tooltip_validation c-tooltip_top-right is-tooltip-validation_invalid">
          <span class="c-label__content">Tooltip at</span>
          <input class="c-input c-input_is-error c-input_small" type="text" placeholder="top-right">
          <span class="c-tooltip__content">Invalid content in field</span>
        </label>
      </div>
    </div>
    <div class="o-grid__cell o-grid__cell_width-33 o-box">
      <div class="c-form-group">
        <div class="c-form-field c-tooltip c-tooltip_validation c-tooltip_top is-tooltip-validation_invalid">
          <label class="c-label" for="inputflc1239" >Tooltip at</label>
          <input class="c-input c-input_is-error" id="inputflc1239" placeholder="top" type="text">
          <span class="c-tooltip__content">Invalid content in field</span>
        </div>
      </div>
      <div class="c-form-group">
        <label class="c-label c-tooltip c-tooltip_validation c-tooltip_top is-tooltip-validation_invalid">
          <span class="c-label__content">Tooltip at</span>
          <input class="c-input c-input_is-error c-input_small" type="text" placeholder="top">
          <span class="c-tooltip__content">Invalid content in field</span>
        </label>
      </div>
    </div>
    <div class="o-grid__cell o-grid__cell_width-33 o-box">
      <div class="c-form-group">
        <div class="c-form-field c-tooltip c-tooltip_validation c-tooltip_top-left is-tooltip-validation_invalid">
          <label class="c-label" for="inputflc1240" >Tooltip at</label>
          <input class="c-input c-input_is-error" id="inputflc1240" placeholder="top-left" type="text">
          <span class="c-tooltip__content">Invalid content in field</span>
        </div>
      </div>
      <div class="c-form-group">
        <label class="c-label c-tooltip c-tooltip_validation c-tooltip_top-left is-tooltip-validation_invalid">
          <span class="c-label__content">Tooltip at</span>
          <input class="c-input c-input_is-error c-input_small" type="text" placeholder="top-left">
          <span class="c-tooltip__content">Invalid content in field</span>
        </label>
      </div>
    </div>
  </div>
</form>

*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Achromatic colors
*/
/*
Chromatic colors (base)
*/
/*
Color tints
*/
/**
 * Primary
 */
/**
 * Secondary
 */
/*
Status colors
*/
/*
Functional colors
*/
/*
Config

 A map of global config settings. Define any project-level configuration, feature switches, etc. in here.

Styleguide 2.1
*/
/*

Tree-table

Advanced table-like component.

*/
.c-editable-form {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;
}

.constraints-message__warning {
  color: red;
}

.one-column_label {
  display: flex;
}
.one-column_label-body {
  width: 75%;
}
.one-column_label-body__full {
  width: 100%;
  max-width: 100%;
}
.one-column_label-value {
  width: 25%;
  max-width: 150px;
}

::ng-deep.close-icon {
  cursor: pointer;
  position: absolute;
  right: 15px;
  display: block;
}

.tooltip-body {
  padding: 0 6px 6px;
  line-height: 1.6428571429;
}

.tooltip-header {
  height: 36px;
  padding: 0 6px;
  font-size: 16px;
}

.input-container {
  display: flex;
  width: 100%;
  margin-bottom: 15px;
}

.icon {
  padding: 10px;
  background: var(--colorBgLevel1);
  color: white;
  min-width: 50px;
  text-align: center;
}

.form_builder {
  width: 100%;
}

.c-input_large2 {
  width: 100%;
}

.dropdown-item {
  display: flex;
  align-items: center;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
